import classnames from 'classnames/bind'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './loading-indicator.module.scss'

const cx = classnames.bind(styles)

const LoadingIndicator = ({ alignItems, className, innerClassName, text }) => {
  const wrapperClassName = cx(className, styles.indicator, {
    alignTop: alignItems === 'top',
    alignBottom: alignItems === 'bottom',
    alignCenter: alignItems === 'center',
    alignStretch: alignItems === 'stretch'
  })

  return (
    <div className={wrapperClassName}>
      <div className={innerClassName}>
        <div className={styles.circle} />
        {text ? <div className={styles.text}>{text}</div> : null}
      </div>
    </div>
  )
}

LoadingIndicator.propTypes = {
  alignItems: PropTypes.string,
  className: PropTypes.string,
  innerClassName: PropTypes.string,
  text: PropTypes.string
}

LoadingIndicator.defaultProps = {
  alignItems: 'center',
  className: null,
  innerClassName: null,
  // TODO [locales] I18nを呼べるようにしてから対応 components.loading_indicator.loading
  text: '読み込み中...'
}

export default LoadingIndicator
